import type { ReactNode } from 'react'
import styles from './style.module.css'

export interface DefinitionItem {
  label: string
  value: ReactNode
}

interface DefinitionListProps {
  items: DefinitionItem[]
  title?: string
}

const DefinitionList = ({ items, title }: DefinitionListProps) => (
  <section className={styles.card}>
    {title ? <h3 className={styles.title}>{title}</h3> : null}

    <dl className={styles.grid}>
      {items.map((item) => (
        <div className={styles.item} key={item.label}>
          <dt className={styles.label}>{item.label}</dt>
          <dd className={styles.value}>{item.value}</dd>
        </div>
      ))}
    </dl>
  </section>
)

export default DefinitionList
